import { Opcion } from "../../../models/catalogo.type"
import * as yup from 'yup'
import { yupResolver } from "@hookform/resolvers/yup"
import { useForm } from "react-hook-form"
import { ContactoSitio } from "./sitio.type"

export const style = {
  borderRadius: '10px',
  background: '#333',
  color: '#fff',
  fontSize: '18px',
}
export type TSitioForm = {
  nombre: string
  razonSocial: Opcion
  nraSemarnat: string
  nraAsea: string
  divisionDeNegocio: Opcion
  procesosActividades: Opcion[] | undefined
  calleNumero: string
  codigoPostal: string
  estado: Opcion
  municipio: string
  colonia: string
  /**
   * Campo de UI para el autocompletado de responsables.
   * No se persiste tal cual; se transforma a `contactos` (idUsuario/nivel) al guardar.
   */
  nombreResponsable: any
  isModoEditar?: boolean
  /**
   * Lista de responsables del sitio.
   * Nota: en la UI se maneja como arreglo en state local; al guardar se serializa como `contactos`.
   */
  arrResponsables: ContactoSitio[]
}

/**
 * Valida los datos minimos para que un sitio pueda operar en el sistema.
 * Incluye identidad, razon social, division de negocio y direccion.
 * Responsables no se validan via yup: se validan via state local antes de guardar.
 */
const schema = yup.object({
  nombre: yup.string().trim().required('El nombre es requerido'),
  razonSocial: yup.object().nullable().required('La razón social es requerida'),
  nraSemarnat: yup.string().trim().required('El NRA SEMARNAT es requerido'),
  divisionDeNegocio: yup.object().nullable().required('La división de negocio es requerida'),
  calleNumero: yup.string().trim().required('La calle es requerida'),
  codigoPostal: yup.string().trim().required('El código postal es requerido'),
  estado: yup.object().nullable().required('El estado es requerido'),
  municipio: yup.string().trim().required('El municipio es requerida'),
  colonia: yup.string().trim().required('La colonia es requerida'),
})

export const useSitioForm = () => {
  return useForm<TSitioForm>({
    mode: 'all',
    resolver: yupResolver(schema),
    defaultValues: {
    },
  })
}
